<form
  [formGroup]="form"
  *ngIf="formInitialized"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper [colSize]="'fixed'" [hideLabel]="true">
      <p-colorPicker
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="form.value.color"
        (ngModelChange)="form.get('color')?.setValue($event)"></p-colorPicker>
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Farbe'" [name]="'color'" [colSize]="1">
      <input
        formControlName="color"
        name="color"
        pInputText
        type="text"
        class="p-input" />
    </app-form-field-wrapper>
    <app-icon-dropdown
      [formField]="form.get('icon')"
      [colSize]="1"
      formControlName="icon"
      label="Icon"
      name="icon"></app-icon-dropdown>
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'name'"
      [colSize]="5"
      [formField]="form.get('name')">
      <input
        pInputText
        id="name"
        type="text"
        formControlName="name"
        class="p-input" />
    </app-form-field-wrapper>
    <app-tag-dropdown
      [colSize]="4"
      formControlName="tags"
      mode="all"></app-tag-dropdown>
  </div>
  <div class="grid">
    <app-form-field-wrapper [label]="'Quelle'" [name]="'geoSource'">
      <textarea
        rows="1"
        cols="30"
        pInputTextarea
        formControlName="geoSource"></textarea>
    </app-form-field-wrapper>
  </div>

  @if (!itemToEdit && allowInitialYears) {
    <h3><i class="fas fa-calendar-days"></i> Jahre hinzufügen</h3>
    <p-divider />

    <div
      class="flex align-items-center gap-3 grid"
      formArrayName="initialYears">
      <ng-container
        *ngFor="
          let yearControl of initialYearsFormArray.controls;
          let i = index
        "
        [formGroupName]="i">
        <app-form-field-wrapper
          styleClass="pt-0"
          [colSize]="2"
          [label]="'Jahr'"
          [name]="'year'"
          [formField]="yearControl.get('year')">
          <input formControlName="year" name="year" pInputText type="text" />
        </app-form-field-wrapper>
      </ng-container>
      <p-button
        [text]="true"
        [raised]="true"
        [rounded]="true"
        pTooltip="Jahr hinzufügen"
        (click)="addYear()"
        icon="fas fa-circle-plus">
      </p-button>

      <p-button
        [text]="true"
        [raised]="true"
        [rounded]="true"
        severity="danger"
        pTooltip="Jahr löschen"
        [disabled]="initialYearsFormArray.length <= 1"
        (click)="removeYear(initialYearsFormArray.length - 1)"
        icon="fas fa-trash p-">
      </p-button>
    </div>
  }

  <p-divider />
  <div class="grid">
    <app-workspace-dropdown
      name="workspaces"
      type="poiDataLayerType"
      formControlName="workspaces"></app-workspace-dropdown>
  </div>

  <p-divider />
  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        permissionService.checkDataLayerRights(itemToEdit._id, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? removeDataLayerType(itemToEdit) : undefined
    "></app-form-footer>
</form>
